module.exports = __webpack_public_path__ + "static/media/manhattan-dark-black-cord.4091d08c.jpg";